import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListCompaniesGroupsComponent } from './components/list-companies-groups/list-companies-groups.component';
import { AddCompaniesGroupsComponent } from './components/add-companies-groups/add-companies-groups.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { FilterGroupComponent } from './components/filter-group/filter-group.component';
import { CustomersFiltersComponent } from '../customers/components/customers-filters/customers-filters.component';
import { UiModule } from 'src/app/ui/ui.module';



@NgModule({
  declarations: [
    ListCompaniesGroupsComponent,
    AddCompaniesGroupsComponent,
    FilterGroupComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    UiModule
  ]
})
export class CompaniesGroupsModule { }
